
















































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  BankDetails,
  Cga,
  FiscalMandate,
  LETTER_STATES,
  Project,
} from '@/model/Project'
import LetterForm from '../../components/core/project/LetterForm.vue'
import { User } from '@/model/User'

@Component({ components: { LetterForm } })
export default class ViewLetter extends Vue {
  projectId = 0
  isCompleting = false
  LETTER_STATES = LETTER_STATES

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin
  }

  get mainProject(): Project {
    return this.$store.getters.mainProject
  }

  get projects(): Project[] {
    return this.$store.getters.projects
  }

  get user(): User {
    return this.$store.getters.user
  }

  get bankDetails(): BankDetails {
    return this.$store.getters.bankDetails
  }

  get cga(): Cga {
    return this.$store.getters.cga
  }

  get fiscalMandate(): FiscalMandate {
    return this.$store.getters.fiscalMandate
  }

  get canReview(): boolean {
    return (
      this.mainProject.letterState === LETTER_STATES.CREATED ||
      this.mainProject.letterState === LETTER_STATES.USER_VALIDATED ||
      this.mainProject.letterState === LETTER_STATES.ADMIN_VALIDATED
    )
  }

  async validateInformation(data: any) {
    this.isCompleting = true
    const updateResponse = await this.$store.dispatch('updateLetter', data)

    if (!updateResponse.success) {
      this.isCompleting = false
      return this.$store.dispatch('toaster/toast', updateResponse)
    }

    const completionResponse = await this.$store.dispatch('completeProject', {
      id: this.projectId,
    })
    this.isCompleting = false
    this.$store.dispatch('toaster/toast', completionResponse)
  }

  @Watch('$route', { immediate: true, deep: true })
  async onUrlChange() {
    const id = +this.$route.params.id
    const siblingsResponse = await this.$store.dispatch(
      'getSiblingsProjects',
      id,
    )
    if (!siblingsResponse.success) return

    const mainProject = siblingsResponse.data.find((p: Project) => p.main)
    if (!mainProject) return

    this.projectId = mainProject.id
    await Promise.all([
      this.$store.dispatch('getUserProject', this.projectId),
      this.$store.dispatch('getProject', this.projectId),
      this.$store.dispatch('getBankDetails', this.projectId),
      this.$store.dispatch('getCga', this.projectId),
      this.$store.dispatch('getFiscalMandate', this.projectId),
    ])
  }
}
